<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="pgepubid00001">
<h2 class="nobreak" id="Inhalt">Inhalt</h2>
</div>
<table class="toc" summary="">
<tbody class="calibre8"><tr class="calibre9">
<td class="s6">
       
    </td>
<td class="s6">
<div class="center">Seite</div>
</td>
</tr>
<tr class="calibre9">
<td class="vat">
<div class="left">Der heilige Aloysius</div>
</td>
<td class="vab">
<div class="center">  <a href="#/Text/Section0003#Der_heilige_Aloysius">1</a></div>
</td>
</tr>
<tr class="calibre9">
<td class="vat">
<div class="left">Die Alt-Pfarrköchin</div>
</td>
<td class="vab">
<div class="center"> <a href="#/Text/Section0004#Die_Alt-Pfarrkoechin">11</a></div>
</td>
</tr>
<tr class="calibre9">
<td class="vat">
<div class="left">D’ Gertrude</div>
</td>
<td class="vab">
<div class="center"> <span href="#/Text/Section0005#DGertrude" title="Link target outside of Sample">35</span></div>
</td>
</tr>
<tr class="calibre9">
<td class="vat">
<div class="left">Ein verdienstliches Werk</div>
</td>
<td class="vab">
<div class="center"> <span href="#/Text/Section0006#Ein_verdienstliches_Werk" title="Link target outside of Sample">83</span></div>
</td>
</tr>
<tr class="calibre9">
<td class="vat">
<div class="left">Die Lenebas</div>
</td>
<td class="vab">
<div class="center"> <span href="#/Text/Section0007#Die_Lenebas" title="Link target outside of Sample">91</span></div>
</td>
</tr>
<tr class="calibre9">
<td class="vat">
<div class="left">Die ehr- und tugendsame Jungfrau Euphrosyne</div>
</td>
<td class="vab">
<div class="center"><span href="#/Text/Section0008#Die_ehr-_und_tugendsame_Jungfrau_Euphrosyne" title="Link target outside of Sample">110</span></div>
</td>
</tr>
<tr class="calibre9">
<td class="vat">
<div class="left">Das Gespenst</div>
</td>
<td class="vab">
<div class="center"><span href="#/Text/Section0009#Das_Gespenst" title="Link target outside of Sample">123</span></div>
</td>
</tr>
<tr class="calibre9">
<td class="vat">
<div class="left">Die Leich’</div>
</td>
<td class="vab">
<div class="center"><span href="#/Text/Section0010#Die_Leich" title="Link target outside of Sample">153</span></div>
</td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?7a870838